<template>
    <div id="resultsPage">
        <v-row v-show="!presenting" class="bigfilters">
            <v-col cols="12" sm="2" xs="12">
                <v-autocomplete
                v-model="selectedParticipants"
                :items="participantNames"
                item-text="text"
                item-value="value"
                :label="$t('results.filter_participants')"
                multiple
                :outlined="true"
                dense
                v-on:input="updateFilters"
                :no-data-text="$t('common.no_data')"
                >
                <template v-slot:selection="{ index }">
                    <span v-if="index === 0" class="grey--text caption">
                    ({{ $t("results.filter_selections") }}:
                    {{ selectedParticipants.length }} )
                    </span>
                </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" xs="12">
                <v-autocomplete
                v-model="selectedClasses"
                :items="classesNames"
                item-text="text"
                item-value="value"
                :label="$t('results.filter_classes')"
                multiple
                :outlined="true"
                v-on:input="updateClassFilters"
                dense
                :no-data-text="$t('common.no_data')"
                >
                <template v-slot:selection="{ index }">
                    <span v-if="index === 0" class="grey--text caption">
                    ({{ $t("results.filter_selections") }}:
                    {{ selectedClasses.length }} )
                    </span>
                </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" xs="12">
                <v-select
                v-model="selectedBrands"
                :items="brandNames"
                item-text="text"
                item-value="value"
                :label="$t('results.filter_brands')"
                multiple
                :outlined="true"
                dense
                v-on:input="updateFilters"
                :no-data-text="$t('common.no_data')"
                >
                <template v-slot:selection="{ index }">
                    <span v-if="index === 0" class="grey--text caption">
                    ({{ $t("results.filter_selections") }}:
                    {{ selectedBrands.length }} )
                    </span>
                </template>
                </v-select>
            </v-col>
            <v-col cols="12" sm="2" xs="12" v-if="bShowingGroups">
                <v-select
                v-model="selectedGroups"
                :items="groupNames"
                item-text="text"
                item-value="value"
                :label="$t('results.filter_groups')"
                multiple
                :outlined="true"
                dense
                v-on:input="updateFilters"
                :no-data-text="$t('common.no_data')"
                >
                <template v-slot:selection="{ index }">
                    <span v-if="index === 0" class="grey--text caption">
                    ({{ $t("results.filter_selections") }}:
                    {{ selectedGroups.length }} )
                    </span>
                </template>
                </v-select>
            </v-col>
            <v-col cols="12" sm="2" xs="12">
                <v-select
                  v-model="selectedSections"
                  :items="sectionItems"
                  item-text="text"
                  item-value="value"
                  :label="$t('results.filter_section_details')"
                  multiple
                  :outlined="true"
                  v-on:input="toggleDetails"
                  dense
                  :no-data-text="$t('common.no_data')"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="selectAllSections">
                      <v-list-item-action>
                        <v-icon>
                          {{ iconSection }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t("races.filter_section_all") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="my-0"></v-divider>
                  </template>
                  <template v-slot:selection="{ index }">
                      <span v-if="index === 0" class="grey--text caption">
                      ({{ $t("results.filter_selections") }}:
                      {{ selectedSections.length }} )
                      </span>
                  </template>
                </v-select>
            </v-col>
            <v-col cols="12" sm="2" xs="12">
              <v-btn tile  @click="updateScores">
                <v-icon left>
                  fas fa-sync
                </v-icon>
                  {{ $tc("results.refresh") }}
              </v-btn>
            </v-col>
        </v-row>
        <VueTabulator ref="tabulator" v-model="filteredResults" :options="tabulatorOptionsComputed"  style="width: 100%"  />
        <SGSNotificationAlert 
          :snackbar="alert" :notificationMessage="$t('results.error_failed')" @cancel="alert = false" 
          type="error" :right="true" :top="true" class="alert"
        />
    </div>
</template>
<script>
import axios from "axios";
import SGSNotificationAlert from "@/components/custom/notification/Alert.vue";

export default {
  name:"Results",
  components: { SGSNotificationAlert },
  async mounted() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/livelaps/race/${this.$route.params.id}`
      ).catch(
          function(error) {
            const status = error.response.status;

            switch (status) {
              case 401:
                window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                break;
            }
          }.bind(this)
        );
      response.data.message.raceId = this.$route.params.id;

      const raceConfigResponse = await axios.get(`${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/livelaps/race/config/${this.$route.params.id}`);

      this.raceInfo = response.data.message;
      this.raceClasses = raceConfigResponse.data.classes.data;
      this.raceColumns = raceConfigResponse.data.columns.data;
      this.raceSections = raceConfigResponse.data.sections.data;
        
      this.scoreHash = this.raceInfo.Score_Hash;
      
      this.setTabulatorColumns();
    } catch (e) {
      // error handled silently
    }
  },
  data() {
    return {
      filteredResults: [],
      filterObj: null,
      tabulatorOptions: {
        ajaxURL: `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/livelaps/race/results/${this.$route.params.id}`,
        layout: "fitDataFill",
        height: 500,
        downloadRowRange: "all",
        resizableColumns: false,
        placeholder: this.$t("common.table.no-data"),
        ajaxResponse: this.tabulatorAjaxResponse,
        dataLoaded: this.getResults,
        ajaxError:function(){
          this.alert = true;
        }.bind(this)
      },
      innerHeight: 500,
      /* Boxes */
      participantNames: [],
      brandNames: [],
      groupNames: [],
      /* FILTERS */
      selectedParticipants: [],
      selectedClasses: [],
      selectedBrands: [],
      selectedGroups: [],
      selectedSections: [],
      timeFormatSelected: 1,
      setZeroForNullColumns: [
        "keyTimeIn",
        "keyTimeOut",
        "recalKeyTimeIn",
        "recalKeyTimeOut",
        "keyTimeDeltaIn",
        "keyTimeDeltaOut",
        "earlyPenaltyIn",
        "earlyPenaltyOut",
        "latePenaltyIn",
        "latePenaltyOut",
        "isDisqualified",
        "classPosition",
        "classBehindBy",
        "readTimeIn",
        "readTimeOut",
        "totalCumulatedTime",
        "totalCumulatedPenalty",
        "overallPosition",
        "overallBehindBy",
        "totalTimeSection",
        "sectionClassPosition",
        "sectionOverallPosition",
        "useKeyTimeIn",
        "timeCheck_penalty",
        "timeCheck_delta",
      ],

      scoreHash: null,
      presenting: false,
      presentingIndex: 0,
      raceClasses: [],
      raceInfo: null,
      raceColumns:[],
      raceSections:[],
      alert: false
    };
  },
  computed: {
    classesNames: function () {
      var data = [];

      for (var i = 0; i < this.raceClasses.length; i++) {
        const cl = {
          text: this.raceClasses[i].name,
          value: this.raceClasses[i].name,
        };

        data.push(cl);
      }

      return data;
    },
    isMode11() {
      if(this.raceInfo) {
        return this.raceInfo.Race_Mode == 11;
      }
      return false;
    },
    sectionItems: function () {
      var data = [];
      if(!this.raceSections || this.raceSections == 'not_found') return [];
      if (this.raceSections.length > 0) {
        this.raceSections.forEach((el,i) => {
          data.push({
            text: el.sectionName, 
            value: i, 
            runLimit: el.runLimit
          });
        });
      }      
      return data;
    },
    isSprint() {
      return this.raceInfo.Race_Mode == 10 && this.raceInfo.Race_Submode == 'sprint';
    },
    likesAllSection() {
      return this.selectedSections.length === this.sectionItems.length
    },
    likesSomeSection() {
      return this.selectedSections.length > 0 && !this.likesAllSection
    },
    iconSection() {
      if (this.likesAllSection) return 'far fa-check-square'
      if (this.likesSomeSection) return 'far fa-square'
      return 'far fa-square'
    },
    bShowingGroups() {
      return this.raceInfo ? this.raceInfo.isShowingGroup : false;
    },
    countLapCheckpoints() {
      const sections = Array.isArray(this.raceSections) ? this.raceSections : [];
      return sections.filter(el => el.sectionType == "LapCheckpoint").length;
    },
    bReliability() {
      return (
        this.raceInfo &&
        this.raceInfo.Race_Mode == 10 &&
        this.raceInfo.Race_Submode == 'reliability'
      )
    },
    translateTabulator() {
      return {
        en: { data: { "no_data": this.$t("common.table.no-data","en") } },
        es: { data: { "no_data": this.$t("common.table.no-data","es") } },
        fr: { data: { "no_data": this.$t("common.table.no-data","fr") } }
      };
    },
    tabulatorOptionsComputed() {
      return {
        ...this.tabulatorOptions,
        locale: this.$i18n.locale,
        langs: this.translateTabulator
      };
    }
  },
  methods: {
    async selectClassDefault(n){
      let _class = this.raceClasses.find(x => x.sortOrder == n);
        if(_class && _class.id > 0){
          this.selectedClasses.push(_class.name);   
        }else{
          this.selectClassDefault(n+1);
        }      
    },
    async getResults(){
      var table = this.$refs.tabulator;
      if(table) {
        table = table.getInstance();
        var _data = table.getData();
        let _localFilter = localStorage.getItem("filter_obj_results");
        if(_localFilter == null){
          this.selectClassDefault(0);
          this.filterObj = {
            selectedClasses: this.selectedClasses,
            idRace: this.$route.params.id
          };
          localStorage.setItem("filter_obj_results", JSON.stringify(this.filterObj));
        }else{
          _localFilter = JSON.parse(_localFilter);
          if(_localFilter.idRace == this.$route.params.id){
            this.selectedClasses = _localFilter.selectedClasses ? _localFilter.selectedClasses:[];
            this.selectedParticipants = _localFilter.selectedParticipants ? _localFilter.selectedParticipants:[];
            this.selectedBrands = _localFilter.selectedBrands ? _localFilter.selectedBrands:[];
            this.selectedGroups = _localFilter.selectedGroups ? _localFilter.selectedGroups:[];
            this.selectedSections = _localFilter.selectedSections ? _localFilter.selectedSections:[];
          }else{
            this.selectClassDefault(0);
            this.filterObj = {
              selectedClasses: this.selectedClasses,
              idRace: this.$route.params.id
            };
            localStorage.setItem("filter_obj_results", JSON.stringify(this.filterObj));
          }
        }
        
        if (this.anyFiltersActive()) {
          let participants = [];
          this.addParticipantsInSelectedClasses(participants, _data);
          this.addSelectedParticipants(participants, _data);
          this.addParticipantsInSelectedBrands(participants, _data);
          this.addParticipantsInSelectedGroups(participants, _data);
          
          if (participants.length === 0) {
            table.setFilter([
              {
                field: "id",
                type: "in",
                value: [-1],
              },
            ]);
          } else {
            table.setFilter([
              {
                field: "id",
                type: "in",
                value: participants,
              },
            ]);
          }
        } else {
          table.setFilter();
        }
      }
    },
    getTranslation(text) {
      return this.$te(text) ? this.$t(text) : text;
    },
    updateClassFilters() {
      this.updateFilters();
      this.setBehindColumn();
    },
  updateFilters() {
    if (!this.$refs.tabulator) {
      return false;
    }

    var table = this.$refs.tabulator.getInstance();
    var data = table.getData();

    if (data.length == 0) {
      table.setFilter();
    }
    
    if (this.anyFiltersActive()) {
      var participants = [];
      this.filterObj = {
        selectedClasses: this.selectedClasses,
        selectedParticipants: this.selectedParticipants,
        selectedBrands: this.selectedBrands,
        selectedGroups: this.selectedGroups,
        selectedSections: this.selectedSections,
        idRace: this.$route.params.id
      };
      localStorage.setItem("filter_obj_results", JSON.stringify(this.filterObj));
      this.addSelectedParticipants(participants, data);
      this.addParticipantsInSelectedClasses(participants, data);
      this.addParticipantsInSelectedBrands(participants, data);
      this.addParticipantsInSelectedGroups(participants, data);
      
      if (participants.length === 0) {
        table.setFilter([
          {
            field: "id",
            type: "in",
            value: [-1],
          },
        ]);
      } else {
        table.setFilter([
          {
            field: "id",
            type: "in",
            value: participants,
          },
        ]);
      }
    } else {
      table.setFilter();
    }
  },
  setTabulatorColumns() {
    var table = this.$refs.tabulator.getInstance();

    var columns = this.raceColumns;
    if (this.raceInfo && this.raceInfo.Race_Mode == 11) {
      columns = this.filterHCColumns(columns);
    }
    var colData = this.setColNames(columns);

    this.innerHeight = window.innerHeight - 250;
    table.setHeight(this.innerHeight);
    table.setColumns(colData);
    if(this.isSprint) {
      this.sectionsSprintExpanded();
    } else {
      table.redraw(true);
    }
    table.setSort("overallPosition", "asc");
  }, 
  filterHCColumns(columns) {
    var isHCField = function(field) {
      return typeof field === 'string' && field.endsWith('HC');
    };
    var hasOnlyHCFields = function(cols) {
      if (!Array.isArray(cols) || cols.length === 0) return false;
      var fields = [];
      var collect = function(arr) {
        arr.forEach(function(c) {
          if (c.field) fields.push(c.field);
          if (Array.isArray(c.columns)) collect(c.columns);
        });
      };
      collect(cols);
      return fields.length > 0 && fields.every(isHCField);
    };
    return columns.filter(function(col) {
      if (col.type === 'forLapHideCheckpoints') return false;
      if (col.field && isHCField(col.field)) return false;
      if (col.columns && hasOnlyHCFields(col.columns)) return false;
      return true;
    });
  },
  getSectionIndexFromColumn(col) {
    if (!col) return null;
    if (typeof col.field == 'string' && col.field.startsWith('sections.')) {
      const indexPart = col.field.split('.')[1];
      const index = parseInt(indexPart, 10);
      return Number.isInteger(index) ? index : null;
    }
    if (Array.isArray(col.columns) && col.columns.length > 0) {
      for (let i = 0; i < col.columns.length; i++) {
        const nestedIndex = this.getSectionIndexFromColumn(col.columns[i]);
        if (nestedIndex !== null) return nestedIndex;
      }
    }
    return null;
  },
  getSectionIndex(field) {
    const match = field.match(/^sections\.(\d+)\./);
    return match ? parseInt(match[1], 10) : null;
  },
  setColNames(columns) {
    var colData = []
    columns.forEach((col) => {
        let colCopy = { ...col };
        if(colCopy.chklap){
            colCopy.cssClass =  `${colCopy.cssClass} ${colCopy.chklap}`;
            delete colCopy.chklap;
        }
        delete colCopy.translate;
        delete colCopy.type;
        if (colCopy.paramsTitle != null && colCopy.paramsTitle.lap != null) {
            colCopy.titleFormatterParams = { ...colCopy.titleFormatterParams, lap: colCopy.paramsTitle.lap };
        }
        if(this.$te(colCopy.title)) {
            const params = colCopy.paramsTitle ? { ...colCopy.paramsTitle } : {};
            colCopy.title = this.$t(colCopy.title, params);
            delete colCopy.paramsTitle;
        }
        if(colCopy.lapNumber) {
            delete colCopy.lapNumber;
        }
        if(colCopy.sectionId) {
            delete colCopy.sectionId;
        }
        if (colCopy.field == 'fullName') {
            colCopy.formatter = this.fullNameFormat
        }
        if (colCopy.sorterFunction) {
          switch (colCopy.sorterFunction) {
            case 'sorterSection':
              colCopy.sorter = this.sorterSection
              break
            case 'sorterGroupPosition':
              colCopy.sorter = this.sorterGroupPosition
              break;
            default:
              colCopy.sorter = this[colCopy.sorterFunction]
          }
          delete colCopy.sorterFunction
        }
        if (colCopy.formatFunction) {
            switch (colCopy.formatFunction) {
                case 'displayTime':
                    colCopy.formatter = this.displayTime
                break
                case 'displayOATime':
                    colCopy.formatter = this.displayOATime
                break
                case 'displayCBTime':
                    colCopy.formatter = this.displayCBTime
                break
                case 'formatMinutes':
                    colCopy.formatter = this.formatMinutes
                break
                case 'formatPenaltyMinutes':
                    colCopy.formatter = this.formatPenaltyMinutes
                break
                case 'brandFormat':
                    colCopy.formatter = this.brandFormat
                break
                case 'displaySectionTime':
                    colCopy.formatter = this.displaySectionTime
                break
                case 'displaySectionTimeSingle':
                    colCopy.formatter = this.displaySectionTimeSingle
                break
                case 'displaySectionTimeArray':
                    colCopy.formatter = this.displaySectionTimeArray
                break
                case 'displayTcTime':
                    colCopy.formatter = this.displayTcTime
                break
                case 'displayTcPenalty':
                    colCopy.formatter = this.displayTcPenalty
                break
                case 'classNameFormat':
                    colCopy.formatter = 'textarea'
                    colCopy.resizable = true
                    colCopy.cssClass = colCopy.cssClass.replace('not-resizable','');
                break
                default:
                    colCopy.formatter = this[colCopy.formatFunction]
            }

            delete colCopy.formatFunction
        }
        if(colCopy.type) delete colCopy.type;
        const sectionPattern = /^sections\.\d+\..+$/;
        const isHcField = (field) => typeof field === 'string' && field.endsWith('HC');
        const allLeafFieldsAreHc = (columns = []) => {
            const fields = [];
            const collectFields = (cols) => {
                cols.forEach((c) => {
                    if (c?.field) fields.push(c.field);
                    if (Array.isArray(c?.columns) && c.columns.length > 0) collectFields(c.columns);
                });
            };
            collectFields(columns);
            return fields.length > 0 && fields.every((f) => isHcField(f));
        };
        let num = -1;
        if (colCopy.field && sectionPattern.test(colCopy.field)) {
            num = this.getSectionIndex(colCopy.field);
            if (this.type == 'overall' && num < 10 && (this.isFirstLoad || this.isWithoutSections)) {
                if(colCopy.visible === true || colCopy.visible === undefined) {
                    this.lastHideColumnsOverall.push(colCopy.field);
                }
                colCopy.visible = false;
            }
        }
        if(colCopy.field == 'overallPosition' && !this.isShowOverall) {
            colCopy.visible = false;
        }
        if (this.isMode11 && colCopy.field && sectionPattern.test(colCopy.field) && !isHcField(colCopy.field)) {
            const lap = colCopy.titleFormatterParams?.lap ?? colCopy.paramsTitle?.lap;
            if (lap != null && lap >= 0) {
                colCopy.cssClass = ((colCopy.cssClass || '').trim() + ' lap-group lap-group-' + lap).trim();
            }
            if (colCopy.titleFormatterParams?.isFirstInLapGroup) {
                colCopy.cssClass = ((colCopy.cssClass || '').trim() + ' lap-group-first').trim();
            }
            colCopy.titleFormatter = this.customHeaderFormatter;
            colCopy.titleFormatterParams = { ...(colCopy.titleFormatterParams || {}), cssClass: 'lap-header-wrap', title: colCopy.title };
        }
        if (colCopy.columns) {
            const hasOnlyHcChildren = allLeafFieldsAreHc(colCopy.columns);
            num = this.getSectionIndex(colCopy.columns[0]?.field);
            colCopy.field = `sections.${num}.columns`;
            if (this.isMode11 && sectionPattern.test(colCopy.field) && !isHcField(colCopy.field) && !hasOnlyHcChildren) {
                const lap = colCopy.titleFormatterParams?.lap ?? colCopy.paramsTitle?.lap;
                if (lap != null && lap >= 0) {
                    colCopy.cssClass = ((colCopy.cssClass || '').trim() + ' lap-group lap-group-' + lap).trim();
                }
                if (colCopy.titleFormatterParams?.isFirstInLapGroup) {
                    colCopy.cssClass = ((colCopy.cssClass || '').trim() + ' lap-group-first').trim();
                }
                colCopy.titleFormatter = this.customHeaderFormatter;
                colCopy.titleFormatterParams = { ...(colCopy.titleFormatterParams || {}), cssClass: 'lap-header-wrap', title: colCopy.title };
            }
            if (this.isMode11) {
                colCopy.columns = this.setColumnsLapCheckpoints(colCopy);
                const isFlatArray = colCopy.columns.some(col => col?.isFlat);
                if (isFlatArray) {
                    colCopy.columns.forEach(col => {
                        const colItem = { ...col };
                        colItem.cssClass = `${(colItem.cssClass || '').trim()} lap-group-flat-mode11`.trim();
                        delete colItem.isFlat;
                        colData.push(colItem);
                    });
                } else {
                    colCopy.columns = colCopy.columns.map(col => {
                        const colItem = { ...col };
                        delete colItem.titleFormatter;
                        delete colItem.titleFormatterParams;
                        const cleanedCssClass = (typeof colItem.cssClass === 'string' ? colItem.cssClass : '')
                            .replace(/\blap-group-first\b/g, '')
                            .replace(/\blap-group-\d+\b/g, '')
                            .replace(/\blap-group\b/g, '')
                            .replace(/\s+/g, ' ')
                            .trim();
                        colItem.cssClass = `${cleanedCssClass} no-top-margin-mode11`.trim();
                        return colItem;
                    });
                    colData.push(colCopy);
                }
            } else {
            colCopy.columns = this.setColNames(colCopy.columns);
                colData.push(colCopy);
        }
        } else {
            colData.push(colCopy);
        }
    });
    return colData
  },
  customHeaderFormatter(column, formatterParams) {            
    const titleFromValue = typeof column.getValue === 'function' ? (column.getValue() ?? '') : '';
    const title = (titleFromValue !== '' ? titleFromValue : (formatterParams && formatterParams.title)) ?? '';
    const lap = formatterParams && formatterParams.lap;

    const lapColumnCount = this.countLapCheckpoints;
    const lapWidth = (lapColumnCount != null && lapColumnCount > 0) ? `${lapColumnCount * 100}%` : '300%';
    if (lap != null && lap >= 0) {
      return `<span class="lap-header-wrap">
                  <span class="lap-header-lap" style="width: ${lapWidth}; background-color: #495464; padding-top: 3px;">${this.$t('races.modal.lap_number', { lap })}</span><br />
                  <span class="lap-header-title">${title}</span>
              </span>`;
    }
    return `<span class="lap-header-wrap"><span class="lap-header-title">${title}</span></span>`;
  },
  fullNameFormat(cell) {
    var fullName = cell.getValue()
    return (
      '<span class="fName">' + fullName + '</span>'
    );
  },
  setColumnsLapCheckpoints(columnParents) {
      const areAllHidden = (cols) => {
          return cols.every(col => {
              if (Array.isArray(col.columns) && col.columns.length) {
                  return areAllHidden(col.columns);
              }
              return col.visible === false;
          });
      };

      const flattenToLeaves = (col) => {
          if (!col.columns || col.columns.length === 0) {
              return [{ ...col, isFlat: true }];
          }
          if (areAllHidden(col.columns)) {
              return [{ ...col, isFlat: true }];
          }
          return col.columns.flatMap(flattenToLeaves);
      };

      const parentLap = columnParents.titleFormatterParams?.lap ?? columnParents.paramsTitle?.lap;

      if (!areAllHidden(columnParents.columns)) {
          let flatColumns = columnParents.columns.flatMap(flattenToLeaves);
          if (parentLap != null) {
              const lapColumnCount = flatColumns.filter(col =>
                  (col.visible === true || col.visible === undefined) &&
                  !(col.field && col.field.endsWith('HC'))
              ).length || flatColumns.length;
              flatColumns = flatColumns.map((col, index) => ({
                  ...col,
                  titleFormatterParams: {
                      ...(col.titleFormatterParams || {}),
                      lap: col.titleFormatterParams?.lap ?? parentLap,
                      isFirstInLapGroup: index === 0,
                      lapColumnCount
                  }
              }));
          }
          return this.setColNames(flatColumns);
      }

      if (parentLap != null) {
          const columnsWithLap = columnParents.columns.map(col => {
              const lap = col.titleFormatterParams?.lap ?? col.paramsTitle?.lap ?? parentLap;
              const childCols = col.columns || [];
              const lapColumnCount = childCols.filter(child =>
                  (child.visible === true || child.visible === undefined) &&
                  !(child.field && child.field.endsWith('HC'))
              ).length || childCols.length;
              const children = childCols.map((child, index) => ({
                  ...child,
                  titleFormatterParams: {
                      ...(child.titleFormatterParams || {}),
                      lap: child.titleFormatterParams?.lap ?? lap,
                      isFirstInLapGroup: index === 0,
                      lapColumnCount
                  }
              }));
              return { ...col, columns: children.length ? children : col.columns, titleFormatterParams: { ...(col.titleFormatterParams || {}), lap } };
          });
          return this.setColNames(columnsWithLap);
      }
      return this.setColNames(columnParents.columns);
  },
    displaySectionTimeSprintDetails(cell) {
        var array = cell.getValue();
        if (typeof array == "undefined") {
            return "";
        }
        let time = "";
        if(array.totalTimeArray) {
            let style = array.totalTimeArray['style'];
            time = array.totalTimeArray['score'];
            if((time || "").length > 0) {
                time = this.formatTime(time);
            } else {
                time = '';
            }
            switch(style) {
                case 'dsq': case 'incomplete':
                    if((time || "").length > 0) time = "<span class='" + style + "'>(" + time + ')</span>';
                break;
                case 'unscored':
                    time = "<span class='unscored'>" + time + "</span>";
                break;
                case 'thrown': case 'fared':
                    time = "<span class='fared'>" + time + '</span>';
                break;
                default: 
                    time = "<span class='bold'>" + time + '</span>';
                break;
            }
            let bandTimeZero = this.validateTimeZero(array.totalTimeArray['score']);
            if (((time || "").length > 0 || style == 'incomplete') && !bandTimeZero && array.totalTimeArray['icon'] != '') {
                var icon = "<i class='" + array.totalTimeArray['icon'] + "'></i>";
                if (array.totalTimeArray['iconPosition'] == 'left') {
                    time = icon + '' + time
                } else if (array.totalTimeArray['iconPosition'] == 'right') {
                    time = time + '' + icon
                } else if (array.totalTimeArray['iconPosition'] == 'kill') {
                    time = icon
                }
            }
            if(
              (time || "").length > 0 && !bandTimeZero && array.sectionOverallPosition && array.sectionOverallPosition != "" && 
              array.sectionClassPosition && array.sectionClassPosition != ""
            ) {
                if(time != '') time += '<br />';
                time += '<span class="sectionPositionText">';
                if (!isNaN(parseInt(array.sectionOverallPosition, 10)) && this.raceInfo.isShowingOverall) {
                    time += ' O(' + parseInt(array.sectionOverallPosition, 10) + ')'
                }
                if (!isNaN(parseInt(array.sectionClassPosition, 10))) {
                    time += ' C(' + parseInt(array.sectionClassPosition, 10) + ')'
                }
                time += '</span>';
            }
            if((time || "").length > 0 && !bandTimeZero) {
                time = time + '<br />' +
                    "<span class='sectionPositionText'>(" +
                    array.avgSpeed +
                    ' ' +
                    array.avgSpeedMeasure +
                    ')</span> <br />';
            }
            if(style == 'incomplete' && (time || "").length > 0) {
                time = time + '<br />';
            }
        }
        return time;
    },
    validateTimeZero(time) {
        if((time || '').length > 0) {
            let timeArray = time.split('.');
            let band = false;
            let allItemTimes = [];
            if(Array.isArray(timeArray)) {
                timeArray.forEach((subTime) => {
                    let subTimeArray = subTime.split(':');
                    subTimeArray.forEach((itemTime) => {
                        allItemTimes.push(itemTime);
                    });
                });
                allItemTimes.forEach((item) => {
                    if(parseInt(item) != 0) {
                        band = true;
                    }
                });
                return !band;
            }
            return false;
        }
        return false;
    },
    displaySectionTimeArray(cell) {
        var array = cell.getValue();
        if (typeof array == "undefined") {
            return "";
        }
        let time = "";
        array.forEach((el) => {
            let _time_value = '';
            let style = el.totalTimeArray['style'];
            let _time = el.totalTimeArray['score'];
            let bandTimeZero = this.validateTimeZero(el.totalTimeArray['score']);
            if((_time || "").length > 0) {
                _time_value = _time = this.formatTime(_time);
            } else {
                _time_value = _time = '';
            }
            switch(style) {
                case 'dsq': case 'incomplete':
                    if((_time || "").length > 0) _time = "<span class='" + el.totalTimeArray['style'] + "'>(" + _time + ')</span>';
                break;
                case 'unscored':
                    _time = "<span class='unscored'>" + _time + "</span>";
                break;
                case 'thrown': case 'fared':
                    _time = "<span class='fared'>" + _time + '</span>';
                break;
                default: 
                    _time = "<span class='bold'>" + _time + '</span>';
                break;
            }
            if (((_time_value || "").length > 0 || style == 'incomplete') && !bandTimeZero && el.totalTimeArray['icon'] != '') {
                var icon = "<i class='" + el.totalTimeArray['icon'] + "'></i>";
                if (el.totalTimeArray['iconPosition'] == 'left') {
                    _time = icon + '' + _time
                } else if (el.totalTimeArray['iconPosition'] == 'right') {
                    _time = _time + '' + icon
                } else if (el.totalTimeArray['iconPosition'] == 'kill') {
                    _time = icon
                }
            }
            if(
                (_time_value || "").length > 0 && !bandTimeZero && el.sectionOverallPosition && el.sectionOverallPosition != "" && 
                el.sectionClassPosition && el.sectionClassPosition != ""
            ) {
                if(_time != '') _time += '<br />';
                _time += '<span class="sectionPositionText">';
                if (!isNaN(parseInt(el.sectionOverallPosition, 10)) && this.raceInfo.isShowingOverall) {
                    _time += ' O(' + parseInt(el.sectionOverallPosition, 10) + ')'
                }
                if (!isNaN(parseInt(el.sectionClassPosition, 10))) {
                    _time += ' C(' + parseInt(el.sectionClassPosition, 10) + ')'
                }
                _time += '</span>';
            }
            if((_time_value || "").length > 0 && !bandTimeZero) {
                time += _time + '<br />' +
                        "<span class='sectionPositionText'>(" +
                        el.avgSpeed +
                        ' ' +
                        el.avgSpeedMeasure +
                        ')</span> <br />';
            }
            if(style == 'incomplete' && (_time || "").length > 0) {
                time += _time + '<br />';
            }
        });
        return time
    },
    displaySectionTimeSingle(cell) {
        let array = cell.getValue()
        if (typeof array == 'undefined' || array['score'] == '' || this.validateTimeZero(array['score'])) {
            return ''
        }
        var time = '';
        if (array['style'] != 'dsq' && !array['isThrown'] && array['style'] != 'incomplete') {
            time = this.formatTime(array['score'])
        } else if (array['isThrown']) {
            time = "<i class='fas fa-ban fared'></i> <span class='fared'>" + this.formatTime(array['score']) + "</span>";
        } else if (array) {
            time = this.formatTime(array['score']);
        } else {
            time = ''
        }

        return time
    },
    displaySectionTime(cell) {
        var array = cell.getValue()
        if (typeof array == 'undefined') {
            return ''
        }
        var time = array['score'];
        if (array['style'] != 'dsq' && array['style'] != 'incomplete') {
            time = this.formatTime(array['score'])
        } else {
            time = array['score']
        }

        if (this.raceInfo.Race_Mode == 6 || this.raceInfo.Race_Mode == 9) {
            if (array['classPosition'] != '' || array['overallPosition'] != '') {
                time += '<br>'
                time += "<span class='sectionPositionText'>"
                if (!isNaN(parseInt(array['overallPosition'], 10)) && this.raceInfo.isShowingOverall) {
                    time += ' O(' + parseInt(array['overallPosition'], 10) + ') '
                }
                if (!isNaN(parseInt(array['classPosition'], 10))) {
                    time += ' C(' + parseInt(array['classPosition'], 10) + ') '
                }
                time += '</span>'
            }
        } else {
            if (
                array['sectionClassPosition'] != '' ||
                array['sectionOverallPosition'] != ''
            ) {
                time += '<br>'
                time += "<span class='sectionPositionText'>"
                if (!isNaN(parseInt(array['sectionOverallPosition'], 10)) && this.raceInfo.isShowingOverall) {
                    time += ' O(' + parseInt(array['sectionOverallPosition'], 10) + ')'
                }
                if (!isNaN(parseInt(array['sectionClassPosition'], 10))) {
                    time += ' C(' + parseInt(array['sectionClassPosition'], 10) + ')'
                }
                time += '</span>'
            }
        }
        //just show empty cell
        if (
                time == '' && array['style'] != 'incomplete' && 
                array['style'] != 'dsq' && array['style'] != 'unscored'
        ) {
                return time
        }
        if (array['style'] == 'dsq') {
            if (time) {
                time = "<span class='dsq'>(" + time + ')</span>'
            } else {
                time = ''
            }
        }

        if (array['style'] == 'incomplete') {
            if (time) {
                time = "<span class='incomplete'>(" + time + ')</span>'
            } else {
                time = ''
            }
        }

        if (array['style'] == 'unscored') {
            if (time) {
                time = "<p class='unscored'>" + time + '</p>'
            } else {
                time = ''
            }
        }

        if (array['style'].includes('thrown')) {
            time = "<span class='fared'>" + time + '</span>'
        }

        if (array['style'] == 'fared') {
            time = "<span class='fared'>" + time + '</span>'
        }

        if (array['icon'] != '') {
            var icon = "<i class='" + array['icon'] + "'></i>"
            if (array['iconPosition'] == 'left') {
              time = icon + '' + time
            } else if (array['iconPosition'] == 'right') {
              time = time + '' + icon
            } else if (array['iconPosition'] == 'kill') {
              time = icon
            }
        }
        return time
    },
    displayTcTime(cell) {
            var array = cell.getValue()

            if (typeof array == 'undefined') {
                return 0
            }

            var time = array['score']

            if (!time) {
                time = 0
            }

            if (array['style'] == 'dsq') {
                if (time) {
                time = "<span class='dsq'>(" + time + ')</span>'
                } else {
                time = ''
                }
            } else {
                if (array['style'] == 'early_dsq') {
                time = "<span class='dsq'>" + time + ' E</span>'
                }
                if (array['style'] == 'late_dsq') {
                time = '' + time + ''
                }
                if (array['style'] == 'fared') {
                time = "<span class='fared'>" + time + '</span>'
                }

                if (array['style'] == 'mr') {
                time = ''
                }
            }

            if (array['style'] == 'timeout' || array['style'] == 'early_timeout') {
                if (time) {
                    time = this.formatTime(time)
                } else {
                    time = ''
                }

                if (array['style'] == 'early_timeout') {
                    time = time + " <span class='dsq'>E </span>"
                }
            }

            if (array['style'] == 'incomplete') {
                time = "<span class='incomplete'>(" + time + ')</span>'
            }

            if (array['style'] == 'unscored') {
                time = "<span class='unscored'>" + time + '</span>'
            }

            if (array['icon'] != '') {
                var icon = "<i class='" + array['icon'] + "'></i>"
                if (array['iconPosition'] == 'left') {
                time = icon + '' + time
                } else if (array['iconPosition'] == 'right') {
                time = time + '' + icon
                } else if (array['iconPosition'] == 'kill') {
                time = icon
                }
            }
            return time
    },
    displayTcPenalty(cell) {
            var array = cell.getValue()
            var time = array['score']

            if (!time) {
                time = '0'
            }

            if (array['style'] == 'dsq') {
                time = "<span class='dsq'>" + time + '</span>'
            } else {
                if (array['style'] == 'early_dsq') {
                time = "<span class='dsq'>" + time + ' E</span>'
                }
                if (array['style'] == 'late_dsq') {
                time = "<span class='dsq'>" + time + ' L</span>'
                }
            }

            if (array['style'] == 'timeout' || array['style'] == 'early_timeout') {
                time = ''

                if (array['style'] == 'early_timeout') {
                time = "<span class='dsq'>E </span>"
                } else {
                time = "<span class='dsq'></span>"
                }
            }

            if (array['style'] == 'incomplete') {
                time = ''
            }

            if (array['style'] == 'unscored') {
                time = ''
            }

            if (array['icon'] != '') {
                var icon = "<i class='" + array['icon'] + "'></i>"
                if (array['iconPosition'] == 'left') {
                time = icon + '' + time
                } else if (array['iconPosition'] == 'right') {
                time = time + '' + icon
                } else if (array['iconPosition'] == 'kill') {
                time = icon
                }
            }
            return time
    },
    formatPenaltyMinutes(cell) {
        var seconds = cell.getValue()
        if (typeof seconds == 'undefined') {
            seconds = 0
        }
        if (seconds === null || seconds.length == 0) {
            seconds = 0
        }
        const time = seconds;
        return time
    },
    brandFormat(cell) {
      var brand = cell.getValue();

      return (
        '<span class="' +
        brand.replace(" ", "").toLowerCase() +
        '">' +
        brand +
        "</span>"
      );
    },
    formatMinutes(cell) {
        var seconds = cell.getValue()
        if (seconds === null || seconds.length == 0) {
            seconds = 0
        }
        seconds = parseInt(seconds, 10)
        return seconds / 60
    },
    displayTime(cell) {
        var data = cell.getValue()
        if (data == '' || !data) {
            return ''
        }
        return this.formatTime(data)
    },
    displayOATime(cell) {
        var data = cell.getValue()
        if (data == '---') {
            return this.getTranslation('races.oa_leader')
        } else {
            return this.formatTime(data)
        }
    },
    displayCBTime(cell) {
        var data = cell.getValue()
        if (data == '---') {
            return this.getTranslation('races.class_leader')
        } else {
            return this.formatTime(data)
        }
    },
    formatTime(data) {
        if (
                data === undefined ||
                data === null ||
                data == '---' ||
                data.length == 0
        ) {
            return data
        }

        data = data + '' //make it a string

        var time = []
        if (data.includes('.')) {
            time = data.split('.')
        } else {
            time[0] = data
        }
        var ms = ''
        if (typeof time[1] != 'undefined' && (time[1] || "").length > 0) {
            ms = time[1].substring(0, 3)
        } else {
            ms = "000";
        }

        var a = time[0].split(':')
        var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
        var minutes = 0;
            
        if (this.timeFormatSelected == 0) {
            ms = ms == '' ? '' : '.' + ms
            seconds = parseInt(seconds, 10) // don't forget the second param
            var hours = Math.floor(seconds / 3600)
            minutes = Math.floor((seconds - hours * 3600) / 60)
            seconds = seconds - hours * 3600 - minutes * 60

            if (hours < 10) {
                hours = '0' + hours
            }
            if (minutes < 10) {
                minutes = '0' + minutes
            }
            if (seconds < 10) {
                seconds = '0' + seconds
            }

            if (isNaN(hours)) {
                hours = 0
            }
            if (isNaN(minutes)) {
                minutes = 0
            }
            if (isNaN(seconds)) {
                seconds = 0
            }
            time = hours + ':' + minutes + ':' + seconds + '' + ms
                
            return time
        }

        if (this.timeFormatSelected == 1) {
            seconds = parseInt(seconds, 10) // don't forget the second param
            minutes = Math.floor(seconds / 60)
            seconds = seconds - minutes * 60
            if (isNaN(minutes)) {
                minutes = 0
            }
            if (isNaN(seconds)) {
                seconds = 0
            }
            minutes = minutes + 'm '
            seconds = seconds + 's '
            time = minutes + '' + seconds + '' + ms
            return time
        }

        return data
    },
    tabulatorAjaxResponse(url, params, response) {
      this.setDataFilters(response.data);
      return response.data;
    },
    setDataFilters(newData) {
      var participants = [];
      var brands = [];
      var groups = [];
      var cl;
      for (var i = 0; i < newData.length; i++) {
        //participants
        participants.push({
          text: `${newData[i].firstName} ${newData[i].lastName} - ${newData[i].displayedNumber}`,
          value: newData[i].id,
        });

        //brands
        if (newData[i].brand) {
          cl = {
            text: newData[i].brand,
            value: newData[i].brand,
          };

          if (!brands.includes(cl)) {
            brands.push(cl);
          }
        }

        //groups
        if (newData[i].classGroup) {
          cl = {
            text: newData[i].classGroup,
            value: newData[i].classGroup,
          };

          if (!groups.includes(cl)) {
            groups.push(cl);
          }
        }
      }
      this.participantNames = this.sortArrays(participants);
      this.brandNames = this.sortArrays(brands);
      this.groupNames = this.sortArrays(groups);
    },
    sortArrays(arrays) {
      return arrays.slice().sort(function (a, b) {
        return a.text > b.text ? 1 : -1;
      });
    },
    async updateScores() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/livelaps/race/${this.raceInfo.raceId}`
        );
        const hash = response.data.message.Score_Hash;

          this.scoreHash = hash;
          var table = this.$refs.tabulator.getInstance();
          table.replaceData();
      } catch {/*----*/}
    },
    setBehindColumn() {
      var table = this.$refs.tabulator.getInstance();

      if (this.selectedClasses.length > 0) {
        table.hideColumn("overallBehindBy");
        table.showColumn("classBehindBy");
      } else {
        table.hideColumn("classBehindBy");
        table.showColumn("overallBehindBy");
      }
      return true;
    },
    toggleDetails() {
      var table = this.$refs.tabulator.getInstance();
      table.blockRedraw();
      var cols = table.getColumnDefinitions();
      
      let sectCols = [];
      let colsField = [];
      //get coltypes

      for (let i = 0; i < cols.length; i++) {
        if (typeof cols[i].columns != "undefined") {
          let type = "s";
          if(this.isSprint) {
            type = "sp";
          } else {
            const colTc = cols[i].columns.map(col => col.field).filter(field => field.includes('recalKeyTimeIn'));
            if(colTc.length > 0) type = "tc";
          }
          sectCols.push(type);
          cols[i].columns.forEach((el1) => {
            colsField.push(el1.field);
          });
        } else if (cols[i].field) {
          colsField.push(cols[i].field);
        }
      }
      
      for (let i = 0; i < this.sectionItems.length; i++) {
        const section = this.sectionItems[i].value;
        
        if (section > -1) {
          if (this.selectedSections.includes(section)) { 
            
            if (sectCols[section] == "s") {

              if(colsField.includes(`sections.${section}.keyTimeIn`)) table.showColumn(`sections.${section}.keyTimeIn`);
              if(colsField.includes(`sections.${section}.readTimeIn`)) table.showColumn(`sections.${section}.readTimeIn`);
              if(colsField.includes(`sections.${section}.penaltyIn`)) table.showColumn(`sections.${section}.penaltyIn`);
              if(colsField.includes(`sections.${section}.keyTimeOut`)) table.showColumn(`sections.${section}.keyTimeOut`);
              if(colsField.includes(`sections.${section}.readTimeOut`)) table.showColumn(`sections.${section}.readTimeOut`);
              if(colsField.includes(`sections.${section}.penaltyOut`)) table.showColumn(`sections.${section}.penaltyOut`);
              if(colsField.includes(`sections.${section}.totalSectionTime`)) table.showColumn(`sections.${section}.totalSectionTime`);
            }

            if (sectCols[section] == "tc") {
              /* timecheck */
              if (!this.bReliability) {
                  if(colsField.includes(`sections.${section}.totalTimeArray`)) table.hideColumn(`sections.${section}.totalTimeArray`)
              }
              
              if(colsField.includes(`sections.${section}.recalKeyTimeIn`)) table.showColumn(`sections.${section}.recalKeyTimeIn`)
              if(colsField.includes(`sections.${section}.readTime`)) table.showColumn(`sections.${section}.readTime`)
              if(colsField.includes(`sections.${section}.tcPenalties`)) table.showColumn(`sections.${section}.tcPenalties`)
              if(colsField.includes(`sections.${section}.keyTimeDeltaOut`)) table.showColumn(`sections.${section}.keyTimeDeltaOut`)
            }

            if(sectCols[section] == 'sp') {
              if(colsField.includes(`sections.${section}.totalTimeSection`)) table.showColumn(`sections.${section}.totalTimeSection`);
              for(let j = 0; j < this.sectionItems[i].runLimit; j++) {
                if(colsField.includes(`sections.${section}.details.${j}`)) table.showColumn(`sections.${section}.details.${j}`);
              }                
            }
          } else {
            if (sectCols[section] == "s") {

              if(colsField.includes(`sections.${section}.keyTimeIn`)) table.hideColumn(`sections.${section}.keyTimeIn`);
              if(colsField.includes(`sections.${section}.readTimeIn`)) table.hideColumn(`sections.${section}.readTimeIn`);
              if(colsField.includes(`sections.${section}.penaltyIn`)) table.hideColumn(`sections.${section}.penaltyIn`);
              if(colsField.includes(`sections.${section}.keyTimeOut`)) table.hideColumn(`sections.${section}.keyTimeOut`);
              if(colsField.includes(`sections.${section}.readTimeOut`)) table.hideColumn(`sections.${section}.readTimeOut`);
              if(colsField.includes(`sections.${section}.penaltyOut`)) table.hideColumn(`sections.${section}.penaltyOut`);
              if(colsField.includes(`sections.${section}.totalSectionTime`)) table.hideColumn(`sections.${section}.totalSectionTime`);
            }

            if (sectCols[section] == "tc") {
              /**timecheck */
              if (!this.bReliability) {
                if(colsField.includes(`sections.${section}.totalTimeArray`)) table.showColumn(`sections.${section}.totalTimeArray`);
              }

              if(colsField.includes(`sections.${section}.recalKeyTimeIn`)) table.hideColumn(`sections.${section}.recalKeyTimeIn`);
              if(colsField.includes(`sections.${section}.readTime`)) table.hideColumn(`sections.${section}.readTime`);
              if(colsField.includes(`sections.${section}.tcPenalties`)) table.hideColumn(`sections.${section}.tcPenalties`);
              if(colsField.includes(`sections.${section}.keyTimeDeltaOut`)) table.hideColumn(`sections.${section}.keyTimeDeltaOut`);
            }

            if(sectCols[section] == 'sp') {
              if(colsField.includes(`sections.${section}.totalTimeSection`)) table.hideColumn(`sections.${section}.totalTimeSection`);
              for(let j = 0; j < this.sectionItems[i].runLimit; j++) {
                  if(colsField.includes(`sections.${section}.details.${j}`)) table.hideColumn(`sections.${section}.details.${j}`);
              }                 
            }
          }
        }
      }
      table.restoreRedraw();
    },
    setTimeFormat() {
      var table = this.$refs.tabulator.getInstance();

      this.timeFormatSelected = this.timeFormatSelected == 0 ? 1 : 0;

      var rows = table.getRows();
      rows.forEach((row) => {
        row.reformat();
      });
    },
    getSortOrder(className) {
      let sortOrder = 0;

      for (var i = 0; i < this.raceClasses.length; i++) {
        if (this.raceClasses[i].name != className) continue;
        sortOrder = this.raceClasses[i].sortOrder;
      }

      return sortOrder;
    },
    setNullToZero(participantIndex, sectionIndex) {
      for (var j = 0; j < this.setZeroForNullColumns.length; j++) {
        //set specific fields, its value to 0 when the value is equals to null
        if (
          typeof this.raceResults[participantIndex].sections[sectionIndex][
            this.setZeroForNullColumns[j]
          ] == "object"
        )
          this.raceResults[participantIndex].sections[sectionIndex][
            this.setZeroForNullColumns[j]
          ] = 0;
      }
    },
    participantsAreEmpty() {
      if (this.$refs.tabulator) {
        var table = this.$refs.tabulator.getInstance();
        if (table.getData().length == 0) {
          return true;
        }
      }

      return false;
    },
    anyFiltersActive() {
      if (
        this.selectedParticipants.length == 0 &&
        this.selectedClasses.length == 0 &&
        this.selectedBrands.length == 0 &&
        this.selectedGroups.length == 0
      ) {
        return false;
      }

      return true;
    },
    sortFilters(data) {
      data.sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
    downloadCsv() {
      const table = this.$refs.tabulator.getInstance();
      table.download("csv", "data.csv", {
        delimiter: ",",
      });
    },
    print() {
      const url = `${process.env.VUE_APP_DOMAIN}/livelaps/scores/print/${this.raceInfo.raceId}`;
      window.open(url, "_blank");
    },
    presentation() {

      var table = this.$refs.tabulator.getInstance();
      if(this.presenting){
        this.innerHeight = window.innerHeight - 250;
        this.presenting = false;

        this.selectedClasses = [];
        this.updateClassFilters();
      } else {
        this.innerHeight = window.innerHeight - 130;
        this.presenting = true;
      }
      table.setHeight(this.innerHeight);

      table.setSort("overallPosition", "asc");
      table.redraw(true);

      if(this.presenting){
        this.presentingIndex = 0;
        this.animateTable(0);
      }
    },
    animateTable(inc){
      //get all classes
      var classes = this.classesNames;

      if(inc == 1){
        this.presentingIndex += 1;
      }

      var ci = this.presentingIndex;


      //if no classes exist, cry (return false)
      if(classes.length == 0 || !this.presenting){
        return false;
      }
      //set class by index passed (ci)
      //if class doesnt exist, call

      if(typeof classes[ci] == 'undefined'){
        this.presentingIndex = 0;
        return this.animateTable(0);
      } else {
        this.selectedGroups = [];
        this.selectedBrands = [];
        this.selectedClasses = [];
        this.selectedParticipants = [];
        this.selectedSections = [];
        this.selectedClasses.push(classes[ci].value);
        this.updateClassFilters();
        this.updateFilters();
        this.toggleDetails();
      }
    },
    moveToNextClass(){
      setTimeout(() => this.animateTable(1), 500);
    },
    addSelectedParticipants(participants, data) {
      for (var i = 0; i < this.selectedParticipants.length; i++) {
        for (var j = 0; j < data.length; j++) {
          const p = data[j];
          if (p.id == this.selectedParticipants[i]) {
            participants.push(p.id);
            break;
          }
        }
      }
      return participants;
    },
    addParticipantsInSelectedClasses(participants, data) {
      for (var i = 0; i < this.selectedClasses.length; i++) {
        for (var j = 0; j < data.length; j++) {
          const p = data[j];
          if (
            p.className == this.selectedClasses[i] &&
            !participants.includes(p.id)
          ) {
            participants.push(p.id);
          }
        }
      }
      return participants;
    },
    addParticipantsInSelectedBrands(participants, data) {
      for (var i = 0; i < this.selectedBrands.length; i++) {
        for (var j = 0; j < data.length; j++) {
          const p = data[j];
          if (
            p.brand == this.selectedBrands[i] &&
            !participants.includes(p.id)
          ) {
            participants.push(p.id);
          }
        }
      }
      return participants;
    },
    addParticipantsInSelectedGroups(participants, data) {
      for (var i = 0; i < this.selectedGroups.length; i++) {
        for (var j = 0; j < data.length; j++) {
          const p = data[j];
          if (
            p.classGroup == this.selectedGroups[i] &&
            !participants.includes(p.id)
          ) {
            participants.push(p.id);
          }
        }
      }
      return participants;
    },
    sorterSection(a, b, aRow, bRow, column, dir) {
        if (!a.score && !b.score) return 0;
            
        if (!a.score) return dir === "asc" ? 1 : -1;
        if (!b.score) return dir === "asc" ? -1 : 1;
            
        var timeA = !this.validateTimeZero(a.score) ? this.timeToMs(a.score) : 0;
        var timeB = !this.validateTimeZero(b.score) ? this.timeToMs(b.score) : 0;
            
        return timeA > timeB ? 1 : timeA < timeB ? -1 : 0;
    },
    sorterSectionLapCheckpoint(a, b, aRow, bRow, column, dir) {
        const fieldName = column.getField();
        const fieldParts = fieldName.split('.');
        const aData = aRow.getData();
        const bData = bRow.getData();
        const aValue = aData[fieldParts[0]][fieldParts[1]]?.totalTimeArray || {};
        const bValue = bData[fieldParts[0]][fieldParts[1]]?.totalTimeArray || {};
        return this.sorterSection(aValue, bValue, aRow, bRow, column, dir);
    },
    sorterSprintSection(a, b) {
        let aValue = (a && a.totalTimeArray) ? a.totalTimeArray.score : a;
        let bValue = (b && b.totalTimeArray) ? b.totalTimeArray.score : b;
        let timeA = aValue && !this.validateTimeZero(aValue) ? this.timeToMs(aValue) : 0;
        let timeB = bValue && !this.validateTimeZero(bValue) ? this.timeToMs(bValue) : 0;
        if (timeA > timeB) {
            return 1
        } else if (timeA < timeB) {
            return -1
        } else {
            return 0
        }
    },
    timeToMs(time) {
        var calcTime = 0
        var multipliers = [1, 60, 3600]

        if (typeof time === 'string' && time != '' && time.includes(':')) {
            var timeArray = time.split(':')

            var arraySize = timeArray.length
            var m = 0
            for (let i = arraySize - 1; i >= 0; i--) {
                if (m > 2) {
                    calcTime = 0
                }
                calcTime += Number(timeArray[i]) * multipliers[m]
                m++
            }
        } else {
            calcTime = time == '' ? 0 : time
        }
        if (calcTime == 0) {
            calcTime = 99999999 //empty scores last
        }
        return calcTime
    },
    sectionsSprintExpanded() {
        let table = this.$refs.tabulator;
        if(!table) return;
        table = table.getInstance();
        setTimeout(() => {
            this.selectAllSections();
            setTimeout(() => {
              table.redraw(true);
            },100);
        },200);
            
    },
    selectAllSections() {
      this.$nextTick(() => {
        if (this.likesAllSection) {
          this.selectedSections = []
        } else {
          this.sectionItems.forEach((elem) => {
            if (!this.selectedSections.includes(elem.value))
              this.selectedSections.push(elem.value)
          })
        }
        this.toggleDetails()
      })
    },
  }
};
</script>

<style lang="scss">
@import "~vue-tabulator/dist/scss/tabulator_site";

$yamaha: #000099;
$ktm: #ff6600;
$honda: #e00031;
$suzuki: #ebd623;
$kawasaki: #33cc00;
$gasgas: #e63429;
$sherco: #0606a8;
$beta: #e60000;
$husqvarna: #002550;
$husaberg: #024fa7;
$tm: #00a2d8;

.theme--dark.v-application #resultsPage {
  color: black;
}

#resultsPage {
  .bigfilters {
    margin-top: 50px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    height: auto;
  }

  .tabulator-page-size {
    -moz-appearance: menulist !important;
    -webkit-appearance: menulist !important;
    appearance: menulist !important;
    background-color: white;
  }

  .tabulator {
    font-family: "Roboto", sans-serif !important;
    font-size: 13px !important;

    &.table-bordered {
      border: 0px;

      .tabulator-header .tabulator-col {
        background-color: #666;
        color: white;
        vertical-align: top;
        border-right: 1px solid rgba(255, 255, 255, 0.25);
      }
    }

    &.table-striped.table-bordered.table-sm {
      font-size: 13px;
    }
  }

  .tabulator .tabulator-header {
    border-bottom: 0px;
    border-top: 0px;
    background: #495464 !important;

    .tabulator-col {
      vertical-align: top !important;
      border-right: 1px solid rgba(255, 255, 255, 0.25) !important;

      .tabulator-col-content {
        vertical-align: top;
        font-size: 13px !important;
        padding: 3px !important;
        text-align: center !important;
      }

      .tabulator-col-title-holder {
        vertical-align: top;
      }
    }

    .tabulator-col-group {
      border-right: 1px solid rgba(255, 255, 255, 0.25) !important;
    }

    .tabulator-col-group-cols {
      border-top: 1px solid rgba(255, 255, 255, 0.25) !important;
      height: auto !important;

      .tabulator-col {
        border-right: 1px solid rgba(255, 255, 255, 0.15) !important;
      }
    }
  }

  .tabulator .tabulator-header .tabulator-col {
    &.lap-group {
      white-space: normal;
      min-height: 48px;
      height: auto;

      .tabulator-col-content,
      .tabulator-col-title-holder,
      .tabulator-col-title {
        white-space: normal;
        line-height: 1.25;
        text-align: center;
        min-width: 80px !important;
      }

      .lap-header-title {
        margin-top: 18px;
      }

      &:not(.lap-group-first) {
        z-index: 1 !important;

        .lap-header-lap {
          display: none;
        }

        .tabulator-col-content,
        .tabulator-col-title-holder,
        .tabulator-col-title {
          z-index: 1 !important;
        }
      }
    }

    &.lap-group-flat-mode11 .tabulator-arrow {
      margin-top: 28px;
    }

    &.no-top-margin-mode11 .tabulator-arrow {
      margin-top: 0 !important;
    }

    .lap-header-wrap {
      display: block;
      text-align: center;
      position: relative;
    }

    .lap-header-title {
      display: block;
      line-height: 1.25;
      margin-top: 4px;
    }

    &.lap-group-first {
      overflow: visible;
      position: relative;
      z-index: 10 !important;

      .tabulator-col-content {
        overflow: visible;
        z-index: 10 !important;
        padding-top: 0 !important;
      }

      .tabulator-col-title-holder {
        position: absolute;
        z-index: 10000 !important;
      }

      .tabulator-col-title {
        z-index: 100000 !important;
      }

      .lap-header-wrap {
        position: inherit;
        z-index: 10 !important;
      }

      .lap-header-lap {
        display: block;
        position: absolute;
        left: 0;
        line-height: 1.2;
        margin-bottom: 2px;
        padding-bottom: 4px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.35);
        text-align: center;
        box-sizing: border-box;
        z-index: 99999 !important;
      }

      .lap-header-title {
        margin-top: 20px;
      }
    }
  }

  .tabulator-col-content {
    font-size: 13px !important;
    padding: 3px !important;
    text-align: center !important;
  }

  .tabulator-cell {
    padding: 0px !important;
    margin: 0px !important;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    font-size: 13px;

    &.tabulator-frozen.tabulator-frozen-left {
      background-color: white;
    }
  }

  .tabulator-row-odd {
    background-color: #eaeaea33;
  }

  .isthrown .tabulator-col-title {
    color: red;
    text-decoration: line-through;
  }

  .isthrown .tabulator-col-group-cols .tabulator-col-title {
    color: white;
    text-decoration: none;
  }

  .isExcludedDisplayed {
    display: none !important;
  }

  .dsq { font-weight: bold; color: red; font-size: 10px; }
  .milliseconds, .section-posittion { font-size: 10px; }
  .fared::before, .fared { color: #f00; font-size: 10px; }
  .fagray::before, .fagray { color: #666; font-size: 10px; }
  .text-blue { color: #002550; }
  .text-small { font-size: 11px; font-weight: bold; }
  .incomplete { color: #002550; font-size: 0.7em; }
  .unscored { color: #002550; font-size: 0.7em; }
  .fill { width: 100%; height: 100%; }
  .sectionPositionText { font-size: 0.8em; }
  .bold { font-weight: 600; }

  .yamaha { background-color: $yamaha; color: #fff; }
  .ktm { background-color: $ktm; color: #fff; }
  .honda { background-color: $honda; color: #fff; }
  .suzuki { background-color: $suzuki; color: #fff; }
  .kawasaki { background-color: $kawasaki; color: #fff; }
  .gasgas { background-color: $gasgas; color: #fff; }
  .sherco { background-color: $sherco; color: #fff; }
  .beta { background-color: $beta; color: #fff; }
  .husqvarna { background-color: $husqvarna; color: #fff; }
  .husaberg, .husaburg { background-color: $husaberg; color: #fff; }
  .tm { background-color: $tm; color: #fff; }
}
</style>